import React from 'react';
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Gallery</h1>
                <p>Home &gt; Gallery</p>
            </div>
        </div>
    )
}

export default Hero;